import { Component, Input } from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { OnInit } from "@angular/core";

@Component({
  selector: "margem-error",
  templateUrl: "./margem-error.component.html",
  styleUrls: ["./margem-error.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class MargemErrorComponent implements OnInit {
  constructor() {}

  @Input() result: any;

  ColumnsMargin: string[] = [
    "marketTypeId",
    "operationTypeId",
    "portfolioDocument",
    "portfolioName",
    "portfolioBank",
    "portfolioBranch",
    "portfolioAccount",
    "portfolioClearingAccount",
    "amount",
    "unitPrice",
    "operationValue",
    "hasSameOwnership",
    "securityType",
    "securityCode",
    "expirationDate",
    "purchaseDate",
    "issuer",
    "command",
    "asset",
    "quotation",
    "isNewCounterpart",
    "counterpartName",
    "counterpartDocument",
    "counterpartClearingAccount",
    "counterpartBrokerAccount",
    "counterpartBank",
    "counterpartBranch",
    "counterpartAccount",
    "annotations",
  ];

  ngOnInit(): void {}
}
